// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";
import { isMobileAppLinkingAssignment } from "@dashboardApi/apis/companiesCompanyIdMobileAppLinkingConfigs";

// iosConfig / androidConfig carry free-form uploaded payloads, so we validate only the stable
// identity fields here; extra keys (the embedded platform configs) are allowed through.
export const isGetCompaniesCompanyIdMobileAppLinkingConfigsIdResult = objectOf({
  id: string,
  name: string,
  assignments: arrayOf(isMobileAppLinkingAssignment),
});
